export default __webpack_public_path__ + "static/media/eps.c712df35.svg";